import { PipeTransform, Pipe } from "@angular/core";
import { Cogs } from '../Model/Cogs.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'cogsFilter',
  standalone: false
})
export class CogsFilterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(cogss: Cogs[], searchTerm: string, field?: string): Cogs[] {
    if (!cogss || !searchTerm?.trim()) {
      return cogss;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return cogss.filter(cogs => {
      if (field && cogs[field]) {
        const fieldValue = this.formatValue(cogs[field], field);
        return fieldValue.includes(lowerSearch);
      }

      const searchableFields = [
        'marketCompanyName',
        'brandName',
        'brandQualityName',
        'size',
        'cogs',
        'applicationDate'
      ];

      return searchableFields.some(key => {
        const value = this.formatValue(cogs[key], key);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any, field: string): string {
    if (value == null) return '';
    if (field === 'applicationDate') {
      const formattedDate = this.datePipe.transform(value, 'MMMM dd, yyyy');
      return formattedDate ? formattedDate.toLowerCase() : '';
    }
    return value.toString().toLowerCase();
  }
}
